












































import {Component, Vue, Prop} from "vue-property-decorator";
import {getCurrentTime} from "@/utils/base";
import { mixins } from "vue-class-component";
import { contentMixin } from "@/components/template-transfer-pc/template/mixins/contentMixin";
import {
  GetTemList,
  EditContent,
  PostCepingContent,
  GetContentDetail,
} from "@/request/common";
import TemplateContent from "@/components/template-transfer-pc/template/template-content.vue";
import QrcodeVue from 'qrcode.vue';

Component.registerHooks([
  "beforeRouteEnter",
  "beforeRouteLeave",
  "beforeRouteUpdate",
]);
@Component({
  components: {
    TemplateContent,
    QrcodeVue
  },
})
export default class Name extends mixins(contentMixin) {
  private dataQuery: any = {
    name: "",
    content_id: "",
    related_type: "",
  };
  private showQrDialog: boolean = false;
  private disabledDate: any = this.endDate();
  private scanBuffer: string = "";
  private lastCharTime: number = 0;
  private scanHandler: any = null;

  private endDate() {
    const self = this;
    return {
      disabledDate(time: any) {
        return time.getTime() > Date.now();
      },
    };
  }

  private get qrCodeUrl() {
    return `https://ceping-mp.xytcmai.com/#/pages/tizhiAnswer/index?name=${this.data.template.name}`;
  }

  private get ifCompose() {
    return this.$store.state.ifCompose;
  }

  private get patient() {
    return this.$store.state.patient;
  }

  private get user() {
    return this.$store.state.user;
  }

  private get systemInfo() {
    return this.$store.state.systemInfo;
  }

  private getData() {
    this.data = {};
    if (this.dataQuery.content_id) {
      this.getContent();
    } else {
      this.getTemplate();
    }
  }

  private goReport(id: any) {
    this.$router.replace({
      path: "/main/report/ceping-report",
      query: {
        ids: JSON.stringify([id]),
      },
    });
  }

  private getTemplate() {
    const params: any = {
      params: {
        name: this.dataQuery.name,
        page: 1,
        ignore_permissions: "true",
      },
    };
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    GetTemList(this, params, loading).then((res: any) => {
      this.data = {
        template: res.data[0],
        collect_time: getCurrentTime("yyyy-MM-dd HH:mm:ss"),
        data: res.data[0].fields,
      };
      this.$forceUpdate();
      console.log("获取模板");
      console.log(this.data);
    });
  }

  private getContent() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    GetContentDetail(this, this.dataQuery.content_id, loading).then(
        (res: any) => {
          this.data = res.data;
          if (!this.data.name && this.data.template && this.data.template.name) {
            this.data.name = this.data.template.name;
          }
        }
    );
  }

  private updateContent(e: any) {
    this.data = e;
  }

  private save() {
    console.log("父组件接收到保存请求");
    console.log(this.data);
    return new Promise((resolve, reject) => {
      (this.$refs.templateContent as any).savePre().then((res: any) => {
        if (res) {
          // 必填验证成功
          const loading = this.$loading({
            lock: true,
            text: "加载中……",
            spinner: "el-icon-loading",
            customClass: "loadClass",
            background: "rgba(255, 255, 255, 0.7)",
          });
          if (this.dataQuery.content_id) {
            EditContent(
                this,
                this.dataQuery.content_id,
                this.data,
                loading
            ).then((res: any) => {
              this.$message.success("保存成功！");
              this.$store.commit("updateIfCompose", false);
              this.getData();
              resolve(true);
            });
          } else {
            const params: any = {
              collect_time: this.data.collect_time,
              patient: this.patient.id,
              data: this.data.data,
              template: this.data.template,
              related_type: this.dataQuery.related_type,
            };
            if (this.data.report) {
              params.report = this.data.report;
            }
            PostCepingContent(this, params, loading).then((res: any) => {
              this.$message.success("保存成功！");
              this.dataQuery.content_id = res.data.id;
              this.$store.commit("updateIfCompose", false);
              this.getData();
              resolve(res);
            });
          }
        } else {
          // 必填验证失败
        }
      });
    });
  }

  private edit() {
    this.$store.commit("updateIfCompose", true);
  }

  private mounted() {
    if (this.$route.query.name) {
      this.dataQuery.name = this.$route.query.name;
    }
    if (this.$route.query.related_type) {
      this.dataQuery.related_type = this.$route.query.related_type;
    }
    if (this.$route.query.content_id) {
      this.dataQuery.content_id = this.$route.query.content_id;
    }
    this.$store.commit("updateIfCompose", true);
    this.getData();

    // 注册扫码枪监听
    this.scanHandler = this.handleScanInput.bind(this);
    window.addEventListener("keydown", this.scanHandler);
  }

    beforeDestroy() {
    if (this.scanHandler) {
      window.removeEventListener("keydown", this.scanHandler);
    }
  }

  private handleScanInput(e: KeyboardEvent) {
    const now = Date.now();
    // 扫码枪输入速度非常快，利用时间间隔判断 (100ms 阈值)
    if (now - this.lastCharTime > 100) {
      this.scanBuffer = "";
    }
    this.lastCharTime = now;

    if (e.key === "￥") {
      this.scanBuffer = "";
      return;
    }

    if (e.key === "#") {
      if (this.scanBuffer) {
        this.handleScanResult(this.scanBuffer);
      }
      this.scanBuffer = "";
      return;
    }

    // 只记录数字
    if (/^\d$/.test(e.key)) {
      this.scanBuffer += e.key;
    }
  }

  private handleScanResult(result: string) {
    if (!this.data || !this.data.data) return;

    // 直接对 this.data 进行深拷贝，确保修改后引用地址改变，触发子组件 Watch
    const newData = JSON.parse(JSON.stringify(this.data));

    // 过滤出有效题目（排除标题、隐藏项）
    const questions = newData.data.filter((item: any) =>
        !item.hide && (item.type === "单选" || item.type === "计分单选")
    );

    const values = result.split("");
    values.forEach((val: string, index: number) => {
      if (index < questions.length) {
        const question = questions[index];
        const optionIndex = parseInt(val) - 1;

        if (optionIndex === -1) {
          // 0 代表没选，重置
          question.value = question.type === "计分单选" ? {} : "";
        } else if (question.options && question.options[optionIndex]) {
          // 必须赋完整的选项对象，以匹配组件内部的对比逻辑
          question.value = question.options[optionIndex];
        }
      }
    });

    // 重新赋值触发响应式更新
    this.data = newData;
    this.$forceUpdate();
    this.$message.success("扫码答案已同步完成");
  }
}
